import "slick-carousel";

/**
 * Initialize hero slider
 *
 * @return {Void}
 */
$(".js-slider-hero").each(function () {
  const $this = $(this);
  const $arrowPrev = $this.find(".js-slider-prev");
  const $arrowNext = $this.find(".js-slider-next");
  let autoPlaySpeed = 3000;

  if ($this.attr("data-slider-speed")) {
    autoPlaySpeed = $this.attr("data-slider-speed");
  }

  $this.find(".js-slides").slick({
    dots: false,
    arrows: false,
    prevArrow: $arrowPrev,
    nextArrow: $arrowNext,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: autoPlaySpeed,
    adaptiveHeight: true,
    rows: 0,
  });
});
